var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"title"},[_vm._v("All languages")]),_vm._l((_vm.languages),function(language){return _c('MenuItem',_vm._b({key:language.id},'MenuItem',language,false))})],2)}
var staticRenderFns = []

export { render, staticRenderFns }